export default "__VITE_ASSET__DJthAL2X__"